export default function () {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line
    dataLayer.push(arguments);
  }
  gtag('js', new Date()); gtag('config', 'G-GJDQ7F8F7Z');
}
